import get from 'lodash/get';
import { isTopic } from 'src/common/utils/guideItemTypes';

export const FETCH_PROFILE = 'FETCH_PROFILE';
export const FETCH_TOPIC_PROFILE = 'FETCH_TOPIC_PROFILE';

const infoAttrsKeyPath = 'children[1].properties.infoAttributes.attributes';
const genreKeyPath = [
  'metadata',
  'properties',
  'classification',
  'rootGenreClassification',
];

// exported for testing
export function mapProfile(profileResponse) {
  const items = profileResponse.items;
  const firstItem = items.shift();

  if (firstItem) {
    const profile = firstItem.children[0];

    profile.metadata = profileResponse.metadata || {};
    profile.containerItems = profileResponse.items;
    profile.infoAttributes = get(firstItem, infoAttrsKeyPath, []);
    profile.rootGenre = get(profileResponse, genreKeyPath, null);

    return profile;
  }

  return {
    isInactive: true,
    metadata: profileResponse.metadata,
    containerItems: [],
  };
}

export function fetchProfileEffect(
  { guideId, itemToken },
  type,
  categoryToPrepend,
) {
  const transform = (resp) => ({
    content: mapProfile(resp.data, guideId),
  });

  return {
    type,
    api: {
      endpoint: ['profile', 'getV3'],
      args: [guideId, { itemToken }],
      transform,
    },
    meta: {
      contentId: guideId,
      categoryToPrepend,
    },
  };
}

// exported for testing
export function fetchTopicEffect({ guideId, apiOptions }) {
  if (isTopic(guideId)) {
    const transform = (resp) => ({ content: resp.data.item });

    return {
      type: FETCH_TOPIC_PROFILE,
      api: {
        endpoint: ['profile', 'get'],
        args: [guideId],
        transform,
        ...apiOptions,
      },
      meta: {
        contentId: guideId,
      },
    };
  }

  return null;
}

export function fetchTopicData(guideId) {
  // NOTE: we don't want API failures for topic fetches to generate app errors (e.g. resulting in
  // 404/500 pages), so disabling them here.
  return fetchTopicEffect({ guideId, apiOptions: { registerAppError: false } });
}

export function fetchProfile(guideItem, categoryToPrepend) {
  return fetchProfileEffect(guideItem, FETCH_PROFILE, categoryToPrepend);
}
